import { Injectable, signal } from '@angular/core';
import { IOtsStaffOrder } from '../interfaces/IOtsStaffOrder';
import { OtsStaffOrderStatus } from '../types';

@Injectable({ providedIn: 'root' })
export class OtsStaffOrdersStore {

  public readonly orders = signal<IOtsStaffOrder[]>([]);
  public readonly cinemaId = signal<number | null>(null);
  public readonly movingOrderIds = signal<ReadonlySet<string>>(new Set());
  public readonly loadError = signal<string | null>(null);
  public readonly searchQuery = signal('');
  public readonly statusFilters = signal<Record<OtsStaffOrderStatus, boolean>>({
    new: true,
    preparing: true,
    ready: true,
    done: true
  });
}
